import styled from 'styled-components';

export const StyledActivityList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 9px;
  width: 100%;
`;
